import { render, staticRenderFns } from "./appointments.vue?vue&type=template&id=cf00c4c6"
import script from "./appointments.vue?vue&type=script&lang=js"
export * from "./appointments.vue?vue&type=script&lang=js"
import style0 from "./appointments.vue?vue&type=style&index=0&id=cf00c4c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports